import { Container, Stack } from '@mui/material';
import AccordionGeneral from 'Global/Components/CommonComponents/AccordionGeneral/AccordionGeneral';
import SingleReactHookFormWrapper from 'Global/Components/Generators/SingleReactHookFormWrapper/SingleReactHookFormWrapper';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import useCreateComplexField from 'Global/Hooks/useCreateComplexField';
import React, { useContext, useRef } from 'react';
import ElementMatcher from './ElementMatcher/ElementMatcher';
import SubmitButton from 'Global/Components/UnEditableComponents/SubmitButton/SubmitButton';
import { SubmitFn } from '../WebAppSettings/functions/SubmitFn';

const NobatPrefrences = () => {
  const nobat_prefrences_title = FindLangKey(
    'main-menu-settings-drawer-nobat-prefrences'
  );

  const submit_label = FindLangKey(
    'general-public-btn-save'
  );

  const markazSettings =
    useContext(GlobalContext)?.appConfig;

  const confirm_msg = FindLangKey(
    'main-menu-drawer-confirm-message'
  );
  const agreement_rules_title = FindLangKey(
    'main-menu-settings-drawer-nobat-agreement-rule-title'
  );

  const { fields, control, formState, handleSubmit } =
    useCreateComplexField(`markazSettings`, markazSettings);

  const submitButton_ref = useRef(null);

  const submitButton_width =
    submitButton_ref.current?.offsetWidth;

  // console.log(
  //   'markazSettingsmarkazSettings-->',
  //   markazSettings
  // );

  return (
    <React.Fragment>
      <Container sx={{ mb: '1em', mt: '1.5em' }}>
        <form
          onSubmit={handleSubmit((data) =>
            SubmitFn(data, confirm_msg)
          )}
        >
          <Stack marginTop={'.5em'}>
            <Stack>
              {fields?.map(
                (field, index) =>
                  field?.TypeSetting?.toLowerCase() ===
                    'nobat' && (
                    <SingleReactHookFormWrapper
                      key={field.id}
                      name={`markazSettings[${index}].Value`}
                      control={control}
                      errors={formState.errors}
                      element={
                        <ElementMatcher
                          field={field}
                          key={field.id}
                          agreement_rules_title={
                            agreement_rules_title
                          }
                          submitButton_width={
                            submitButton_width
                          }
                        />
                      }
                    />
                  )
              )}
              <div
                style={{
                  marginTop: '.5em',
                }}
                ref={submitButton_ref}
              >
                <div>
                  <SubmitButton label={submit_label} />
                </div>
              </div>
            </Stack>
          </Stack>
        </form>
      </Container>
    </React.Fragment>
  );
};

export default NobatPrefrences;
